var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavReportsActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6A04E4D3-F037-4843-8F54-90873EEBD670") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Company-Portal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard1",
    transform: "translate(-18.000000, -532.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    x: 0,
    y: 0,
    width: 1680,
    height: 1015
  }), /*#__PURE__*/React.createElement("g", {
    id: "Nav-CompanyAdmin"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "none",
    x: 0,
    y: 0,
    width: 245,
    height: 1015
  }), /*#__PURE__*/React.createElement("g", {
    id: "Nav-Off",
    transform: "translate(0.000000, 521.000000)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Reports",
    transform: "translate(18.000000, 532.000000)",
    fill: "#C3D34F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,20 L8,20 C6.34314575,20 5,18.6568542 5,17 L5,7 C5,6.44771525 4.55228475,6 4,6 C3.44771525,6 3,6.44771525 3,7 L3,17 C3,19.7614237 5.23857625,22 8,22 L16,22 C16.5522847,22 17,21.5522847 17,21 C17,20.4477153 16.5522847,20 16,20 Z M10,13 C10,13.5522847 10.4477153,14 11,14 L16,14 C16.5522847,14 17,13.5522847 17,13 C17,12.4477153 16.5522847,12 16,12 L11,12 C10.4477153,12 10,12.4477153 10,13 Z M21,8.94 C20.9895837,8.8481349 20.9694716,8.75763058 20.94,8.67 L20.94,8.58 C20.8919189,8.47717975 20.8277838,8.38266483 20.75,8.3 L20.75,8.3 L14.75,2.3 L14.75,2.3 C14.6673352,2.22221621 14.5728202,2.15808108 14.47,2.11 C14.4401498,2.10576018 14.4098502,2.10576018 14.38,2.11 C14.2784148,2.05174135 14.1662233,2.0143442 14.05,2 L10,2 C8.34314575,2 7,3.34314575 7,5 L7,15 C7,16.6568542 8.34314575,18 10,18 L18,18 C19.6568542,18 21,16.6568542 21,15 L21,9 C21,9 21,9 21,8.94 Z M15,5.41 L17.59,8 L16,8 C15.4477153,8 15,7.55228475 15,7 L15,5.41 Z M19,15 C19,15.5522847 18.5522847,16 18,16 L10,16 C9.44771525,16 9,15.5522847 9,15 L9,5 C9,4.44771525 9.44771525,4 10,4 L13,4 L13,7 C13.0027046,7.34114324 13.0635775,7.67932599 13.18,8 L11,8 C10.4477153,8 10,8.44771525 10,9 C10,9.55228475 10.4477153,10 11,10 L19,10 L19,15 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavReportsActive);
export default __webpack_public_path__ + "static/media/NavReportsActive.c1846b04c3f260a6ba529370e82ccb23.svg";
export { ForwardRef as ReactComponent };